export default __webpack_public_path__ + "static/media/No.1-6.79a3e302.jpg";